export const ClubsIcon = (props) => {
  // const { className } = props;

  return <h5 style={{ marginBottom: 0 }}>C</h5>;
};
